import React, { useState, useEffect } from "react";

import BearGraphicSVG from "../../common/logos/BearGraphic";
import BgImg from "../../common/backgrounds/BgImg";

import { useNavigate } from "react-router-dom";

export default function TutorialPage() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(process.env.PUBLIC_URL + "/game");
  };

  return (
    <div className="page">
      <BgImg />
      <div className="UI_Block">
        <h1>How to Play</h1>
        <BearGraphicSVG width={200} />
        <h2>
          <strong>Billy the Bear is hiding at Canalside Quarter!</strong>
        </h2>

        <br />

        <h2>
          Move around the development to find him! If you complete all 5 levels
          without running out of time, you could win
        </h2>
        <h2>
          <strong> your very own Billy the Bear!</strong>
        </h2>

        <br />

        <br />

        <button className="button" onClick={handleClick}>
          Play
        </button>
      </div>
    </div>
  );
}
